import { render, staticRenderFns } from "./FarmFeedTypesView.vue?vue&type=template&id=7acfbd09&"
import script from "./FarmFeedTypesView.vue?vue&type=script&lang=ts&"
export * from "./FarmFeedTypesView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports